import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
/**
 * テキストアイテムのアイテムコントローラー
 */
export default class ItemControllerFreeText {
  target: marietta.webcad.item.MonicaObject;

  allBox: marietta.webcad.control.parts.BoundingBox;

  rotator: marietta.webcad.control.parts.ControlRotator;

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  rotation: number;

  width: number;

  height: number;

  dragStartPoint: marietta.core.Point;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  padding: number;

  rotatorPadding: number;

  private btnDelete: marietta.webcad.control.parts.ButtonGarbage;

  private btnTextSetting: marietta.webcad.control.parts.ButtonTextSetting;

  private btnDragger: marietta.webcad.control.parts.DraggerMobile;
  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    // ターゲット
    this.target = _target;
    this.initMe();
  }

  /**
   * 初期化関数
   * viewObjの作成
   */
  initMe() {
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);
    // 回転
    this.rotator = new marietta.webcad.control.parts.ControlRotator(viewObj);
    this.rotator.rotateStartFunc = this.rotateStart;
    this.rotator.rotateFunc = this.rotate;
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnTextSetting = new marietta.webcad.control.parts.ButtonTextSetting(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    this.padding = this.target.itemInfo.font_size / 3;
    this.rotatorPadding = 30;
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);
    // SVGSpriteのwidth/heightに書き換え
    const bounding = this.target.viewObj.getBoundingClientRect();
    const width: number = bounding.width / marietta.webcad.WebCADGlobal.scaleSize;
    const height: number = bounding.height / marietta.webcad.WebCADGlobal.scaleSize;
    // ピッカーの位置調整
    this.rotator.move(-6.5, -height / 2 - 23);
    // 全体Box
    this.allBox.resize({ width: width + this.target.itemInfo.font_size / 4, height: height - this.target.itemInfo.font_size / 4 });
    this.allBox.move(0, 0);
    this.updateIconButtons();
    // 回転角度を元に戻す
    this.target.rotate(motoRot);
    this.rotation = motoRot;
    this.updateTransforms();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.rotation = this.target.itemInfo.rotation;
    this.updateTransforms();
  }

  /**
   * 回転の開始
   */
  rotateStart = () => {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();
    const { width } = this.target.spt;
    const { height } = this.target.spt;
    this.allBox.move(-width / 2, -height / 2);
  };

  /**
   * 回転する
   * @param e
   */
  rotate = (e: MouseEvent) => {
    const firstPoint: marietta.core.Point = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
    const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);
    // レイヤーのスケーリング分を考慮
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
    secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
    secondPoint.x /= root.scaleX;
    secondPoint.y /= root.scaleY;
    // 角度
    const radian: number = Math.atan2(firstPoint.x - secondPoint.x, firstPoint.y - secondPoint.y);
    let angle: number = -radian / (Math.PI / 180) + 360;
    const unit: number = 45;
    if (angle % unit > 5 && angle % unit < unit - 5) {
      this.rotator.showAssist(false);
    } else {
      this.rotator.showAssist(true);
      angle = Math.round(angle / unit) * unit;
    }
    this.rotation = angle;
    this.updateTransforms();
    // ターゲットを回転
    this.target.rotate(angle);
    if (this.emptySpt) {
      this.emptySpt.setEmptyParam(this.target.spt);
    }
  };

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = this.rotation;
    this.spt.update();
  }

  /**
   * コントロールピッカーが移動された
   */
  private onMoveDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;
    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      if (this.emptySpt === undefined) {
        /*
            本来はtarget.sptのmouseX/mouseYで取得できるが、
            拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
            そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
            取得している。
          */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.btnDragger.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      // ドラッグの開始位置
      this.dragStartPoint = new marietta.core.Point(this.target.spt.mouseX * this.target.spt.scaleX, this.target.spt.mouseY * this.target.spt.scaleY);
    }
    const newPoint: marietta.core.Point = new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY);
    // ターゲットの移動
    this.target.move(newPoint.x, newPoint.y);
    // ターゲットに吸着
    this.syncMeToTarget();
  };

  /**
   * コントロールピッカーのドラッグ終了
   */
  private onMoveEndDragger = () => {
    this.dragStartPoint = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  };

  /**
   * アイコンボタンの更新
   */
  private updateIconButtons() {
    const bounding = this.target.viewObj.getBoundingClientRect();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete.move(bounding.width / 2 + 35 + this.target.itemInfo.font_size / 4, 0);
      // 編集ボタン
      this.btnTextSetting.move(-bounding.width / 2 - 35 - this.target.itemInfo.font_size / 4, 0);
      // 移動軸
      this.btnDragger.move(0, bounding.height + 35 - this.target.itemInfo.font_size);
    }
  }

  private hideToolTips() {
    // モバイル
    this.rotator.hide();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.hide();
      this.btnDragger.hide();
      this.btnTextSetting.hide();
    }
  }

  private showToolTips() {
    // モバイル
    this.rotator.show();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.show();
      this.btnDragger.show();
      this.btnTextSetting.show();
    }
  }
}
